import { navigate } from "gatsby";
import React , {useEffect, useState} from "react";
import {getInfo} from "../../service/loyaltyService";
import { useLocation } from '@reach/router';

const Menu = (props)=>{
    
    const location = useLocation();
    let page = location.pathname;
    const [cardName, setCardName] = useState();
    useEffect(()=>{
        getInfo(window.localStorage.getItem('key')).then((response)=>{
            window.localStorage.setItem('cardname', response['message'].dataCard?.class_name);
            window.localStorage.setItem('cardcode', response['message'].dataCard?.class_code);
            window.localStorage.setItem('collect', parseInt(response['message'].dataProcess?.collect,0));
            setCardName(response['message'].dataCard?.class_name);
        });
    },[]);

    const handleClick=(uri)=>{
        navigate(uri);
    }
    return(
        <div className="detail-order-left h-100">
            <span className="left-header-text">Xin chào, {window.localStorage.getItem('name')}</span>
            <div className="order-left-header">
                <div className="left-header-lever">
                    <span>Khách hàng {cardName}</span>
                    <i className="fa fa-angle-right"></i>
                </div>

                <div className="order-left-code">
                    <span>Mã khách hàng thân thiết</span>
                    <span className="code-num">{window.localStorage.getItem('memberCard')}</span>
                </div>
            </div>

            <div className="order-left-list pdb-20">
                <ul>
                    <li className={page === '/account/manager.html' ? ('list-select'):(null)} onClick={()=>handleClick('/account/manager.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_user.svg" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Tài khoản</span>
                            </div>
                        </div>
                    </li>
                    <li className={page === '/account/personalized.html'? ('list-select'):(null)} onClick={()=>handleClick('/dac-quyen.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_dac_quyen.svg" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Đặc quyền thành viên</span>
                            </div>
                        </div>
                    </li>
                    {/* <li className={page === '/account/service.html'? ('list-select'):(null)} onClick={()=>navigate('/account/service.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_tien_ich_dich_vu.svg" alt="icon"/>
                            </div>   
                            <div className="in-f">
                                <span>Tiện ích, dịch vụ</span>
                            </div>   
                        </div>     
                    </li> */}
                    <li className={page === '/account/orders.html'  || page === '/account/orderdetail.html' ? ('list-select'):(null)}  onClick={()=>handleClick('/account/orders.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_don_hang_cua_ban.svg" alt="icon"/>
                            </div>    
                            <div className="in-f">
                                <span className="reqire-list">Đơn hàng</span>
                            </div>
                        </div>    
                    </li>
                    <li className={page === '/account/support.html' ? ('list-select'):(null)}  onClick={()=>handleClick('/account/support.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_ho_tro_nguoi_dung.svg" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Hỗ trợ người dùng</span>
                            </div>
                        </div>
                    </li>
                    <li className={page === '/account/police.html' ? ('list-select'):(null)}  onClick={()=>handleClick('/account/police.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_quy_dinh_chinh_sach.svg" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Quy định, chính sách</span>
                            </div>
                        </div>
                    </li>
                    <li className={(page === '/account/noti.html' || page === '/noti.html') ? ('list-select'):(null)}  onClick={()=>handleClick('/account/noti.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="../images/web_app/tk_thong_bao_bai_viet.svg" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Thông báo, bài viết</span>
                            </div>
                        </div>
                    </li>
                    
                    <li className={page === '/account/about.html' ? ('list-select'):(null)}  onClick={()=>handleClick('/account/about.html')}>
                        <div className="row mgx-0 in-f">
                            <div className="box-svg-menu in-f pdr-10">
                                <img src="/images/account/Frame_766145.png" alt="icon"/>
                            </div>
                            <div className="in-f">
                                <span>Về Bibo Mart</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        
    )
}

export default Menu;